<template>
    <span class="ui-gram-icon"
        v-on:mouseenter="tooltipVisible = true"
        v-on:mouseleave="tooltipVisible = false">
        <icon-gram class="ui-gram-icon__svg"/>
        <ui-tooltip v-if="tooltipVisible" value="GRAM" position="top"/>
    </span>
</template>

<script>
import IconGram from '@img/icons/tonscan/gram-icon.svg?vue';

// The coin glyph that stands in for the ticker next to an amount, the way
// fragment prints its prices; the ticker itself lives in the tooltip.
export default {
    data() {
        return {
            tooltipVisible: false,
        };
    },

    components: {
        IconGram,
    },
};
</script>

<style lang="scss">
.ui-gram-icon {
    position: relative;
    display: inline-flex;
    vertical-align: -2px;
    margin-right: 5px;
    cursor: default;

    &__svg {
        width: 16px;
        height: 16px;
    }

    // The default offset is measured for the taller tag pills:
    .tip-tooltip-wrapper-top {
        top: -36px;
    }
}
</style>
